export const getFormErrorMessage = (name, errors) => {
  return errors[name] ? (
    <small className="p-error">{errors[name].message}</small>
  ) : (
    <small className="p-error">&nbsp;</small>
  );
};
